import { Controller } from 'react-hook-form';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Control } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { Radio } from 'antd';
import { PRODUCT_STOCK_TYPE_OPTION_LIST } from 'commons/options';

const ProductSkuType = ({
  control,
  productId,
}: {
  control: Control<CreateProductFormSchemaType>;
  productId?: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.WgIPBPPxEU)}:</FormLabel>
      <Controller
        name="skuType"
        control={control}
        render={({ field }) => (
          <Radio.Group
            {...field}
            optionType="button"
            buttonStyle="solid"
            disabled={!!productId}
          >
            {PRODUCT_STOCK_TYPE_OPTION_LIST.map(({ value, labelKey }) => {
              return (
                <Radio value={value} key={value}>
                  {i18n.t(labelKey)}
                </Radio>
              );
            })}
          </Radio.Group>
        )}
      />
    </div>
  );
};

export default ProductSkuType;
